
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Swiftdzireonrentinpuneforcorporate() {



    const cardData =
    {
        keyword: 'Swift Dzire on Rent in Pune for Corporate ',
        heading: 'etravo : Swift Dzire on Rent in Pune for Corporate  ',



"headingDescription": "eTravo offers reliable Swift Dzire on Rent in Pune for Corporate Travel, designed for businesses, IT companies, and professionals who need affordable, comfortable, and fuel-efficient transportation. The Swift Dzire is ideal for daily office pickup and drop, client meetings, airport transfers, and small business travel needs. With GPS-enabled vehicles, experienced chauffeurs, and clean, well-maintained sedans, eTravo ensures safe, punctual, and smooth corporate mobility across Pune.",

"top": "Top Corporate Use Cases for Swift Dzire in Pune with eTravo",

"topPlaces": [
  {
    "title": "Hinjewadi IT Park",
    "description": "Pune’s largest IT hub where Swift Dzire is widely used for employee pickup and drop services and daily shift commuting."
  },
  {
    "title": "Kharadi IT Park",
    "description": "A major corporate zone with EON IT Park and World Trade Center, requiring cost-effective sedan transport for employees."
  },
  {
    "title": "Magarpatta City",
    "description": "A structured IT township where Swift Dzire is ideal for regular office commuting and corporate transport services."
  },
  {
    "title": "Hadapsar",
    "description": "An important IT and industrial zone where Swift Dzire is commonly used for daily employee transportation and business travel."
  },
  {
    "title": "Baner-Balewadi",
    "description": "A growing corporate hub where startups and offices prefer Swift Dzire for executive travel and small team movement."
  },
  {
    "title": "Viman Nagar",
    "description": "A premium business area near Pune Airport where Swift Dzire is frequently used for airport transfers and corporate pickups."
  },
  {
    "title": "Wakad",
    "description": "A residential base for IT professionals commuting to Hinjewadi, making Swift Dzire a popular daily cab option."
  },
  {
    "title": "Koregaon Park",
    "description": "A high-end locality where Swift Dzire is used for client meetings, executive travel, and business visits."
  },
  {
    "title": "Shivajinagar",
    "description": "A central business district where Swift Dzire supports official travel and corporate office commuting."
  },
  {
    "title": "Pimpri-Chinchwad",
    "description": "A large industrial and corporate zone where Swift Dzire is used for employee transport and business mobility."
  }
],


"services": [
{
"name": "Swift Dzire Hire Pune",
"description": "eTravo offers Swift Dzire hire in Pune for comfortable and economical travel. Ideal for corporate use and daily commuting, our vehicles ensure smooth rides with professional chauffeurs and well-maintained interiors."
},
{
"name": "Dzire Cab Pune",
"description": "Our Dzire cab services in Pune provide reliable and efficient transportation for city travel and outstation trips. eTravo ensures punctual service and a comfortable journey for every ride."
},
{
"name": "Swift Dzire Rental Pune",
"description": "eTravo provides Swift Dzire rental services in Pune with flexible booking options. Our vehicles are perfect for business travel, airport transfers, and daily commuting needs."
},
{
"name": "Dzire Taxi Pune",
"description": "Choose Dzire taxi services in Pune by eTravo for smooth and hassle-free travel. Our taxis are well-maintained and driven by experienced chauffeurs for safe and comfortable journeys."
},
{
"name": "Corporate Dzire Hire Pune",
"description": "eTravo offers corporate Dzire hire in Pune designed for employee transport and executive travel. Our service ensures punctual pickups, comfortable seating, and reliable performance for business operations."
},
{
"name": "Dzire Car Rental Pune",
"description": "eTravo provides Dzire car rental services in Pune for both short-term and long-term use. Our vehicles are clean, efficient, and suitable for all types of travel requirements."
},
{
"name": "Dzire Office Cab Pune",
"description": "eTravo offers Dzire office cab services in Pune for smooth daily commuting. Our service ensures safe and timely travel for employees between home and workplace."
},
{
"name": "Dzire Cab Booking Pune",
"description": "Book a Dzire cab in Pune with eTravo for a seamless travel experience. Our easy booking process and dependable service ensure comfort and convenience."
},
{
"name": "Dzire Company Car Pune",
"description": "eTravo provides Dzire company car services in Pune tailored for corporate needs. Our vehicles are ideal for employee transport and business travel with reliable service."
},
{
"name": "Dzire Travel Cab Pune",
"description": "Our Dzire travel cab services in Pune are designed for comfortable city and outstation journeys. eTravo ensures smooth travel with professional drivers and well-maintained cars."
},
{
"name": "Dzire Fleet Pune",
"description": "eTravo offers Dzire fleet services in Pune for businesses requiring multiple vehicles. Our fleet ensures consistent quality, proper maintenance, and dependable transportation."
},
{
"name": "Dzire Employee Transport Pune",
"description": "eTravo provides Dzire employee transport services in Pune for safe and efficient commuting. Our service ensures punctual pickups and comfortable rides for daily travel."
},
{
"name": "Dzire Hire Service Pune",
"description": "Our Dzire hire services in Pune offer flexible and reliable transportation solutions. eTravo ensures quality vehicles and professional drivers for a smooth travel experience."
},
{
"name": "Dzire Corporate Travel Pune",
"description": "eTravo offers Dzire corporate travel services in Pune for business trips and meetings. Our service ensures reliability, comfort, and punctuality for professional travel."
},
{
"name": "Dzire Rental Service Pune",
"description": "eTravo provides Dzire rental services in Pune with a focus on convenience and affordability. Our service ensures smooth and hassle-free travel for all customer needs."
}
],
"tableData": [
["Swift Dzire Hire Pune", "Dzire Cab Pune"],
["Swift Dzire Rental Pune", "Dzire Taxi Pune"],
["Corporate Dzire Hire Pune", "Dzire Car Rental Pune"],
["Dzire Office Cab Pune", "Dzire Cab Booking Pune"],
["Dzire Company Car Pune", "Dzire Travel Cab Pune"],
["Dzire Fleet Pune", "Dzire Employee Transport Pune"],
["Dzire Hire Service Pune", "Dzire Corporate Travel Pune"],
["Dzire Rental Service Pune", ""]
],





"whychoose": [
    {
      "WhyChooseheading": "Best Swift Dzire on Rent in Pune for Corporate",
      "WhyChoosedescription": "eTravo offers reliable Swift Dzire rental for corporate in Pune, delivering a perfect combination of comfort, efficiency, and affordability for employee transport and business travel."
    },
    {
      "WhyChooseheading": "Ideal Sedan for Corporate Travel Needs",
      "WhyChoosedescription": "Swift Dzire is a compact sedan designed for smooth city rides, making it ideal for daily office commute, client meetings, and executive travel across Pune."
    },
    {
      "WhyChooseheading": "Fuel-Efficient and Budget-Friendly Option",
      "WhyChoosedescription": "Dzire is known for its excellent mileage, helping companies reduce travel costs while maintaining a comfortable and professional travel experience."
    },
    {
      "WhyChooseheading": "Comfortable Seating and Smooth Ride Quality",
      "WhyChoosedescription": "With comfortable interiors and a smooth suspension system, Swift Dzire ensures a relaxed journey for employees and corporate clients."
    },
    {
      "WhyChooseheading": "Professional Chauffeur-Driven Service",
      "WhyChoosedescription": "Our trained drivers provide punctual, safe, and professional service, ensuring a hassle-free travel experience with proper corporate etiquette."
    },
    {
      "WhyChooseheading": "Flexible Rental Plans for Corporate Clients",
      "WhyChoosedescription": "eTravo offers hourly, daily, monthly, and long-term rental plans for Swift Dzire, allowing businesses to customize travel solutions based on their needs."
    },
    {
      "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
      "WhyChoosedescription": "All vehicles are regularly serviced and cleaned to ensure safety, hygiene, and comfort for daily corporate travel."
    },
    {
      "WhyChooseheading": "24/7 Support for Corporate Travel Needs",
      "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, schedule changes, and urgent travel requirements."
    }
  ]

}

const faqData = [
    [
        {
            question: 'What is Swift Dzire rental for corporate in Pune?',
            answer: 'Swift Dzire rental for corporate in Pune is a chauffeur-driven cab service offering comfortable sedan vehicles for employee transport, meetings, and business travel.',
        },
        {
            question: 'Why is Swift Dzire suitable for corporate travel?',
            answer: 'Swift Dzire is fuel-efficient, comfortable, and affordable, making it a popular choice for daily office commute and corporate travel.',
        },
        {
            question: 'Can I book Swift Dzire for daily office pickup and drop?',
            answer: 'Yes, Swift Dzire is commonly used for daily employee transportation with fixed routes and schedules.',
        },
        {
            question: 'Is Swift Dzire available for airport transfers in Pune?',
            answer: 'Yes, Swift Dzire cabs are widely used for airport pickup and drop services for corporate employees and clients.',
        },
        {
            question: 'Do Swift Dzire rentals include a driver?',
            answer: 'Yes, all Swift Dzire corporate rentals come with professional chauffeur-driven service.',
        },
        {
            question: 'Can I book Swift Dzire for outstation corporate travel?',
            answer: 'Yes, Swift Dzire is suitable for both local and outstation corporate trips including one-way and round-trip bookings.',
        },
        {
            question: 'Are monthly Swift Dzire rental plans available?',
            answer: 'Yes, eTravo offers monthly and long-term Swift Dzire rental plans for corporate clients.',
        },
        {
            question: 'Is Swift Dzire cost-effective for companies?',
            answer: 'Yes, Swift Dzire provides a budget-friendly option for corporate travel without compromising comfort.',
        },
        {
            question: 'Are vehicles sanitized and well-maintained?',
            answer: 'Yes, all vehicles are regularly serviced and cleaned to ensure safety and hygiene.',
        },
        {
            question: 'How can I book Swift Dzire on rent in Pune for corporate?',
            answer: 'You can book online or contact the support team for quick and customized corporate travel solutions.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Rahul Shinde',
        designation: 'Admin Executive, IT Company, Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“We regularly use Swift Dzire from eTravo for corporate travel in Pune. It is economical, comfortable, and always on time.”',
    },
    {
        name: 'Ms. Priya Kulkarni',
        designation: 'HR Manager, Corporate Firm, Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo’s Dzire rental service is perfect for employee transport. The service is reliable, and the vehicles are clean and well-maintained.”',
    },
];









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Swift Dzire on Rent in Pune for Corporate",
  "image": [
    "https://www.etravo.in/images/keyword/swift-dzire-rent-pune.jpg"
  ],
  "description":
    "Affordable Swift Dzire rental for corporate use in Pune by eTravo. Ideal for employee transport, office travel, staff pickup and drop, and business trips with comfortable and fuel-efficient rides.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "sku": "SWIFT-DZIRE-PUNE-CORPORATE",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "1250",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.etravo.in/swift-dzire-on-rent-in-pune-for-corporate",
    "priceCurrency": "INR",
    "price": "2199",
    "availability": "https://schema.org/InStock",
    "itemCondition": "https://schema.org/NewCondition"
  }
};



    return (
        <div>


<Helmet>
  <title>
    Swift Dzire on Rent in Pune for Corporate | Office & Staff Cab Service | eTravo
  </title>

  <meta
    name="description"
    content="Hire Swift Dzire on rent in Pune for corporate use with eTravo. Perfect for employee transport, office travel, staff pickup and drop, and business commute needs."
  />

  <link
    rel="canonical"
    href="https://www.etravo.in/swift-dzire-on-rent-in-pune-for-corporate"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/137.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Swiftdzireonrentinpuneforcorporate;